import { Nullable } from '@homeserve/od-typings/utils';
import { Validator } from 'vee-validate';

interface IDateMinParam {
  dateMin: string;
}

interface IDateMaxParam {
  dateMax: string;
}

export function isLesserThan(value: Nullable<string>, args: object | any[]): boolean {
  if (!value) {
    return false;
  }

  const { dateMax } = args as IDateMaxParam;

  return new Date(value) < new Date(dateMax);
}

export function isGreaterThan(value: Nullable<string>, args: object | any[]): boolean {
  if (!value) {
    return false;
  }

  const { dateMin } = args as IDateMinParam;

  return !(dateMin && new Date(value) < new Date(dateMin));
}

Validator.extend('date_lesser_than', isLesserThan, {
  paramNames: ['dateMax'],
});

Validator.extend('date_greater_than', isGreaterThan, {
  paramNames: ['dateMin'],
});
